import { SearchIcon } from 'tuui';
import { CampaignGroupSorting } from '../CampaignGroupSorting/CampaignGroupSorting';
import styles from '../CampaignPickerValueContainer/CampaignPickerValueContainer.module.scss';
import commonStyles from '../commonPickerDropdownStyle.module.scss';

export const CampaignGroupPickerValueContainer = ({ children, onSort, sort }) => {
    return (
        <div className={styles['container']}>
            <div className={styles['search-container']}>
                <div className={styles['search-icon-wrapper']}>
                    <SearchIcon fontSize="small" className={commonStyles['search-icon']} />
                </div>
                <div className={styles['input-container']}>{children}</div>
            </div>
            <CampaignGroupSorting sort={sort} onSort={onSort} />
        </div>
    );
};
